/* istanbul ignore file */
export const themeFontWeight = (weight) => (props) =>
  props.theme.font ? props.theme.font.weights[weight] : 'inherit'
export const themeFontSize =
  (size, defaultSize = 'inherit') =>
  (props) =>
    props.theme ? props.theme.font.sizes[size] : defaultSize
export const themeColor = (color) => (props) =>
  props.theme && props.theme.colors ? props.theme.colors[color] : 'inherit'
export const themeBorderRadius = () => (props) =>
  props.theme ? props.theme.decoration.radius : 'inherit'
const printFontFamily = (family) =>
  `font-family: ${family
    .split(',')
    .map((family) => `"${family.trim()}"`)
    .join(',')};`
export const themeFontFamily = () => (props) => {
  if (!Array.isArray(props.theme.fontFamily)) {
    return printFontFamily(props.theme.fontFamily)
  }
  const screens = Object.keys(props.theme.screens)
  const families = [...props.theme.fontFamily]
  const defaultFamily = families.pop()
  return `
    ${printFontFamily(defaultFamily)}
    ${families
      .map(
        (family, index) => `@media (max-device-width: ${
          props.theme.screens[screens[index]]
        }) {
      ${printFontFamily(family)}
    }`
      )
      .join(' ')}
  `
}
export const themeMediaQuery = (screenSize) => (props) =>
  `@media screen and (min-width: ${props.theme.screens[screenSize]})`
export const themeMediaQueryMinMax = (key) => (props) => {
  const { min, max } = props.theme.screensMinMax[key]

  let query = '@media screen'

  if (min) {
    query = `${query} and (min-width: ${min})`
  }

  if (max) {
    query = `${query} and (max-width: ${max})`
  }

  return query
}
